import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { SharingScreen } from "../../screens/settings/SharingScreen.tsx";

/** `/settings/sharing`: the company's rules for public links and every link there is. */
export const Route = createFileRoute("/_app/settings/sharing")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("sharing.links", {})),
  component: SharingScreen,
});
